import React, { useEffect, useMemo, useState, useCallback } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CommonDataTable from "../../../components/CommonDataTable";
import { getItemList } from "../../../services/skuItem/skuItem";

const rawColumns = [
  { field: "itemCode", headerName: "Item Code", width: 160 },
  { field: "itemName", headerName: "Item Name", width: 180 },
  { field: "category", headerName: "Category", width: 140 },
  { field: "subCategory", headerName: "Sub Category", width: 160 },
  { field: "brand", headerName: "Brand", width: 140 },
  { field: "uom", headerName: "UOM", width: 100 },
  { field: "condition", headerName: "Condition", width: 120 },
  { field: "status", headerName: "Status", width: 120 },
  { field: "dimension", headerName: "Dimension", width: 140 },
];

export default function SkuListing({ onCreateClick, refreshKey, onView, onEdit }) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [tableRows, setTableRows] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // ---------------- LOAD LIST ----------------
  const loadList = useCallback(async (page, pageSize) => {
    try {
      

        const res = await getItemList(page, pageSize);
        

        if (Object.keys(res).length!=0) {
           
          const formatted = res.list.map((item) => ({
            itemCode: item.itemCode,
            itemName: item.itemName,
            category: item.category,
            subCategory: item.subCategory,
            brand: item.brand,
            uom: item.uom,
            condition:item.condition,
            status: item.status,
             dimension:item.dimension,
            __original: item,
            id: item._id,
          }));

          setTableRows(formatted);
          setTotalCount(res.pagination.totalRecords);
        } else {
          setTableRows([]);
          setTotalCount(0);
        }
    
    } catch (err) {
      console.error(err);
      setTableRows([]);
      setTotalCount(0);
    }
  }, []);

  useEffect(() => {
    loadList(page, pageSize);
  }, [refreshKey, page, pageSize, loadList]);

  // ---------------- MENU HANDLING ----------------
  const handleOpenMenu = (e, row) => {
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
    setMenuRow(row);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const actionColumn = {
    field: "__actions",
    headerName: "",
    width: 80,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <IconButton
        size="small"
        onClick={(e) => handleOpenMenu(e, params.row)}
        aria-label="row actions"
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
    ),
  };

  const allPossibleColumns = useMemo(
    () => [actionColumn, ...rawColumns],
    []
  );

  const initialVisible = useMemo(
    () => allPossibleColumns.map((c) => c.field),
    [allPossibleColumns]
  );

  return (
    <>
      <CommonDataTable
        allPossibleColumns={allPossibleColumns}
        initialVisible={initialVisible}
        initialRows={tableRows}
        height={520}
        rowsPerPageOptions={[10, 25, 50, 100]}
        exportImportPath="ItemMaster"
        forItems
        showCreateButton
        createButtonText="Create Item"
        createButtonIcon="bi-plus-lg"
        onCreateClick={onCreateClick}
        createButtonVariant="contained"
        createButtonColor="primary"
        page={page}
        pageSize={pageSize}
        rowCount={totalCount}
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
          setPage(0);
        }}
         onDataRefresh={async ({ filters = [], page: p = 0, pageSize: ps = pageSize } = {}) => {

                    console.log("ASN ....................... received onDataRefresh:", { filters, page: p, pageSize: ps });

                }}
      />

      <Menu
        open={!!menuAnchorEl}
        anchorEl={menuAnchorEl}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={() => onView(menuRow?.__original)}>
          <i className="bi bi-eye me-2" /> View
        </MenuItem>
        <MenuItem onClick={() => onEdit(menuRow?.__original)}>
          <i className="bi bi-pencil me-2" /> Edit
        </MenuItem>
      </Menu>
    </>
  );
}
